import { render } from "./TestimonialsPage.vue?vue&type=template&id=1015d418&ts=true"
import script from "./TestimonialsPage.vue?vue&type=script&lang=ts"
export * from "./TestimonialsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__